<template>
  <div class="editor-promo-block__edit-wrapper">
    <EditorContentEditable
      class="editor-promo-block__link"
      :contenteditable="editing"
      placeholder="Ссылка"
      :class="{ edit: editing }"
      :text="href"
      @input="handleInput"
    />
    <EditorEditButton
      v-if="!editing"
      icon="editor/setting"
      @click="allowEdit"
    />
    <EditorEditButton v-else icon="editor/apply" @click="handleApply" />
    <EditorEditButton icon="editor/delete" @click="emit('delete')" />
  </div>
</template>

<script setup>
const props = defineProps({
  href: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['change', 'error', 'delete']);

const localHref = ref('');
const editing = ref(false);

watch(
  props.href,
  (value) => {
    localHref.value = value;
  },
  { immediate: true },
);

const allowEdit = () => {
  editing.value = true;
};

const handleInput = (e) => {
  localHref.value = e.target.textContent;
};

const handleApply = () => {
  if (!localHref.value) {
    emit('error', 'Введите ссылку');
    return;
  }

  editing.value = false;
  emit('change', localHref.value);
};
</script>
